<template>
	<div class="index-swiper-view">
		<van-pull-refresh v-model="isRefreshing"
						  @refresh="onRefresh"
						  v-if="selectedNavItemId == 1"
						  class="sub-view--index"
						  id="indexNewsList">
			<van-swipe :autoplay="2000">
				<van-swipe-item v-for="item in bannerList"
								:key="item.id">
					<div class="swiper-banner-wrap">
						<BannerItem v-bind="item" />
						<!-- <img class="banner-img" :src="item.img_path" /> -->
					</div>
				</van-swipe-item>
			</van-swipe>
			<div class="news-list">
				<NewsItem v-for="item in newsItemList"
						  :key="item.id"
						  v-bind="item"
						  :beforeClick="()=>{onNewsItemClick(item.id)}" />
			</div>
			<div class="tag-list">
				<TagItem v-for="item in tagItemListOnShow"
						 :key="item.id"
						 v-bind="item"
						 :click="onTagClick" />
				<TagItem v-show="!showAllTag"
						 name="展开更多"
						 :isPrimary="true"
						 @click.native="showAllTag = true" />
				<TagItem v-show="showAllTag"
						 name="收起"
						 :isPrimary="true"
						 @click.native="showAllTag = false" />
			</div>
			<div class="view-list-wrap">
				<div class="header">
					<span class="text--header">学院推荐</span>
					<router-link to="/college">
						<span class="text--sub">查看全部</span>
					</router-link>
				</div>
				<div class="college-list">
					<!-- <div
          class="college-item"
          v-for="item in collegeList"
          :key="item.id"
          @click="onCourseClick(item.id)"
        >
          <img class="cover-img" v-lazy="item.cover" />
          <div class="mask" v-if="item.file_type === 2">
            <img class="play-img" src="../../assets/images/play_white.png"/>
          </div>
          <span class="title text--sub">{{ item.title }}</span>
        </div> -->
					<CourseItem v-for="item in collegeList"
								:key="item.id"
								v-bind="item"
								@click="onCourseClick(item.id)" />
				</div>
			</div>

			<div class="view-list-wrap">
				<div class="header">
					<span class="text--header">智库推荐</span>
					<router-link to="/digital">
						<span class="text--sub">查看全部</span>
					</router-link>
				</div>
				<div class="digital-list">
					<DigitalItem v-for="item in digitalList"
								 :key="item.id"
								 v-bind="item" />
				</div>
			</div>

			<div class="group-news-list">
				<div class="group-news-item"
					 v-for="(item, index) in groupNewsItemList"
					 :key="index">
					<div class="banner-wrap">
						<img class="banner-img"
							 v-lazy="item.banner.img_path" />
					</div>
					<div class="news-list">
						<NewsItem v-for="news in item.list"
								  :key="news.id"
								  v-bind="news"
								  :beforeClick="()=>{onNewsItemClick(news.id)}" />
					</div>
				</div>
			</div>
		</van-pull-refresh>
		<van-pull-refresh v-model="isRefreshing"
						  @refresh="onRefresh"
						  v-else
						  class="sub-view--other"
						  v-infinite-scroll="loadMore"
						  :infinite-scroll-disabled="bottomLoading"
						  id="otherNewsList">
			<div class="news-list">
				<NewsItem v-for="item in newsItemList"
						  :key="item.id"
						  v-bind="item"
						  :beforeClick="()=>{onNewsItemClick(item.id)}" />
				<div v-if="selectedNavItemId==2" class="no-content-wrap">
					<img v-show="isNoContent && firstLoaded" class="no-fav-img" src="../../assets/images/no_fav.png"/>
				</div>
				<div v-else class="no-content"
					 v-show="isNoContent && firstLoaded">———— 暂无内容 ————</div>

			</div>
		</van-pull-refresh>
		<PopLoading v-show="isLoading" />
	</div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'
import { getUser, getChannel, getChannels, getFollowingChs } from '../../utils/storageUtil'
import apiUtil from '../../utils/apiUtil'
import apiConst from '../../consts/apiConst'
import NewsItem from '../../components/NewsItem'
import TagItem from '../../components/TagItem'
import DigitalItem from '../../components/DigitalItem'
import CourseItem from '../../components/CourseItem'
import BannerItem from '../../components/BannerItem'
import PopLoading from '../../components/PopLoading'
export default {
	name: 'indexSwiperView',
	components: {
		'van-swipe': Swipe,
		'van-swipe-item': SwipeItem,
		NewsItem,
		TagItem,
		DigitalItem,
		CourseItem,
		BannerItem,
		PopLoading
	},
	props: {
		selectedNavItemId: {
			type: Number,
			default: 1
		},
		viewedNewsId: {
			type: Number,
			default: 0
		},
		firstLoadedHandler: {
			type: Function,
			default: () => { }
		}
	},
	data() {
		return {
			bannerList: [],
			newsItemList: [],
			tagItemList: [],
			collegeList: [],
			digitalList: [],
			groupNewsItemList: [],

			showAllTag: false,

			isLoading: false, // 是否正在加载（菊花）
			isRefreshing: false, // 是否正在下拉刷新

			// 以下只有other才会用到
			bottomLoading: false, // 是否正在触底加载
			page: 1,
			loadFinished: false, // 分页加载是否结束
			isNoContent: false, // 是否无内容
			firstLoaded: false // 是否已经首次加载

		}
	},
	created() {
		this.initView(this.selectedNavItemId)
	},

	computed: {
		tagItemListOnShow() {
			return this.showAllTag
				? this.tagItemList
				: this.tagItemList.slice(0, 9)
		}
	},
	watch: {
		selectedNavItemId(val) {
			this.initView(val);
		}
	},
	methods: {
		/**
		 * @param isDragDown 是否由下拉刷新触发
		 */
		initView(selectedNavItemId, isDragDown) {
			if (selectedNavItemId === 1) {
				this.initIndexView(isDragDown)
			} else {
				this.initOtherView(selectedNavItemId, 1, isDragDown)
			}
		},

		async initIndexView(isDragDown) {
			if (!isDragDown) {
				this.isLoading = true
			}
			const res = await apiUtil.post(apiConst.getDiscoverIndex, {})
			this.isLoading = false
			this.isRefreshing = false
			if (res) {
				const {
					home_banner,
					college,
					digital,
					group_top_news,
					tag,
					top_news,
				} = res
				this.bannerList = home_banner
				this.tagItemList = tag
				this.newsItemList = top_news
				this.collegeList = college.slice(0, 4)
				this.digitalList = digital
				let groupNewsItemList = []
				for (let item in group_top_news) {
					if (group_top_news.hasOwnProperty(item)) {
						groupNewsItemList.push(group_top_news[item])
					}
				}
				this.groupNewsItemList = groupNewsItemList.slice(0, 2);
				if (!this.firstLoaded) {
					this.scrollToNewsItem(isDragDown)
				}
				this.firstLoaded = true;
			}
		},

		async initOtherView(selectedNavItemId, page = 1, isDragDown) {

			let params = { cate_id: selectedNavItemId, page, pagesize: 50 };
			if (selectedNavItemId == 2) {
				const user = getUser();
				if (!user) {
					const channels = getFollowingChs();
					if (!!channels) {
						params.localstorage = channels.map(ele => ele.id);
					}
				}
			}
			if (!isDragDown) {
				this.isLoading = true
			}
			const res = await apiUtil.post(apiConst.getOther, params)
			this.isLoading = false;
			this.isRefreshing = false
			if (res.success) {
				const {
					list
				} = res
				this.page = page;
				if (list.length === 0) {
					this.isNoContent = true;
					this.firstLoaded=true;
					return;
				}
				if (this.firstLoaded) {
					this.newsItemList = this.newsItemList.concat(list);
				} else {
					this.newsItemList = list;
					this.scrollToNewsItem(isDragDown)
				}
				this.firstLoadedHandler();
				if (list.length < 50) {
					this.loadFinished = true;
				}
				this.firstLoaded = true;
			}
		},

		scrollToNewsItem(isDragDown) {
			if (this.viewedNewsId && !isDragDown) { // 下拉刷新是不需要定位到刚刚访问的newsItem的
				this.$nextTick(() => {
					let dom = document.getElementById('news_' + this.viewedNewsId);
					if (dom) {

						this.scrollToPos(dom.offsetTop - 250)
					}
				})

			}
		},

		scrollToPos(dis) {
			this.$nextTick(() => {
				setTimeout(() => {
					let scrollTop;
					if (this.selectedNavItemId == 1) {
						scrollTop = this.$el.querySelector('#indexNewsList')
					} else {
						scrollTop = this.$el.querySelector('#otherNewsList')
					}
					scrollTop.scrollTop = dis
				}, 13)
			})
		},

		onNewsItemClick(id) {
			let query = {
				newsId: id
			}
			if (this.selectedNavItemId !== 1) {
				query.cate_id = this.selectedNavItemId
			}
			this.$router.push({ query })
		},

		resetView() {
			this.page = 1;
			this.loadFinished = false;
			this.isNoContent = false;
			this.firstLoaded = false;
			this.newsItemList = [];
		},

		onTagClick(tag_id) {
			this.$router.push({ name: 'filtered', query: { tag_id } })
		},

		onRefresh() {
			this.resetView();
			this.initView(this.selectedNavItemId, true);
		},

		loadMore() {
			if (!this.loadFinished && this.firstLoaded) {
				this.initOtherView(this.selectedNavItemId, this.page + 1, false)
			}
		},
	}
}
</script>

<style lang="stylus" scoped>
.index-swiper-view {
	height: 100%;

	.van-pull-refresh {
		height: 100%;
		-webkit-overflow-scrolling: touch

		overflow-y: auto;

		.van-swipe {
			height: auto !important;

			.swiper-banner-wrap {
				margin: 30px auto;
				width: 690px;
				height: 273px;
				border-radius: 12px;
				overflow: hidden;

				.banner-img {
					display: block;
					width: 100%;
					height: 100%;
				}
			}
		}

		.tag-list {
			margin: 0 15px;
			padding-top: 23px;
			border-bottom: 2px solid #F1F1F1;

			.tag-item-comp {
				margin: 0 10px 23px;
			}
		}

		.college-list {
			padding: 20px 0;

			.course-item-comp {
				margin-left: 30px;
				margin-bottom: 30px;
				vertical-align: top;
			}
		}

		.digital-list {
			padding: 20px 0;

			.digital-item-comp {
				margin-left: 30px;
				margin-bottom: 30px;
				vertical-align: top;
			}
		}

		.group-news-list {
			.group-news-item {
				margin-bottom: 23px;

				.banner-wrap {
					padding: 0 30px;
					height: 273px;
					overflow: hidden;

					.banner-img {
						width: 100%;
						height: 100%;
						border-radius: 12px;
					}
				}
			}
		}
	}

	.news-list {
		padding: 0 15px;
	}

	.sub-view--other {
		height: 100%;

		.news-list {
			position: relative
			height: 100%;
			overflow-y: auto;

			.no-content {
				height: 90px;
				line-height: 90px;
				color: #999;
				text-align: center;
			}

			.no-content-wrap{
				text-align: center;
				.no-fav-img {
					margin-top: 20px;
				width: 400px;
			}
			}

			
		}
	}
}
</style>
